import { createContext, useContext, useEffect, useState } from "react";
import api from '../services/api';
import { useAuth } from "../context/AuthContext"; // Import Auth Context to listen for login changes

const UserSettingsContext = createContext();

export const UserSettingsProvider = ({ children }) => {
  const [userSettings, setUserSettings] = useState(null);
  const { user } = useAuth(); // Get the logged-in user from AuthContext

  useEffect(() => {
    if (!user) return; // Prevent fetching if the user is not logged in

    api.get("/DefaultSettings")
      .then((response) => setUserSettings(response.data))
      .catch((error) => console.error("Error fetching settings:", error));
  }, [user]); // Re-fetch when the user changes

  return <UserSettingsContext.Provider value={userSettings}>{children}</UserSettingsContext.Provider>;
};

export const useUserSettings = () => useContext(UserSettingsContext);
